import type { KindDef } from './types';
import * as home from './home';
import * as hangar from './hangar';
import * as cottage from './cottage';
import * as stairs from './stairs';
import * as classic from './classic';
import * as gliderpro from './gliderpro';
import * as appliances from './appliances';
import * as outdoor from './outdoor';
import * as furnishings from './furnishings';
import * as fixtures from './fixtures';

export const KINDS: Record<string, KindDef> = {
  window: home.windowKind,
  bed: home.bedKind,
  desk: home.deskKind,
  chair: home.chairKind,
  deskLamp: home.deskLampKind,
  pendant: home.pendantLampKind,
  bookshelf: home.bookshelfKind,
  poster: home.posterKind,
  frame: home.frameKind,
  wallClock: home.wallClockKind,
  toyBox: home.toyBoxKind,
  rug: home.rugKind,
  nightstand: home.nightstandKind,
  dresser: home.dresserKind,
  books: home.booksStackKind,
  pencils: home.pencilCupKind,
  switchPlate: home.switchKind,
  floorVent: home.floorVentKind,
  drip: home.dripKind,
  sideTable: home.sideTableKind,
  candle: home.candleStickKind,
  fan: home.fanStandKind,
  frontDoor: home.frontDoorKind,
  bathtub: home.bathtubKind,
  sink: home.sinkKind,
  towelRail: home.towelRailKind,
  radiator: home.radiatorKind,
  ceilingVent: home.ceilingVentKind,
  plant: home.plantKind,
  shelf: home.shelfKind,
  banister: home.banisterKind,
  stairsUp: stairs.stairsUpKind,
  stairsDown: stairs.stairsDownKind,
  toaster: home.toasterKind,
  girder: hangar.girderKind,
  hangarWindow: hangar.hangarWindowKind,
  markers: hangar.markersKind,
  baySign: hangar.baySignKind,
  hazardStripe: hangar.hazardStripeKind,
  launcher: hangar.launcherKind,
  block: hangar.blockKind,
  targetMat: hangar.targetMatKind,
  hoop: hangar.hoopKind,
  fireplace: cottage.fireplaceKind,
  grandfatherClock: cottage.grandfatherClockKind,
  armchair: cottage.armchairKind,
  stove: cottage.stoveKind,
  kettle: cottage.kettleKind,
  dresserHutch: cottage.dresserHutchKind,
  rockingChair: cottage.rockingChairKind,
  cuckooClock: cottage.cuckooClockKind,
  teaTable: cottage.teaTableKind,
  knittingBasket: cottage.knittingBasketKind,
  cottageWindow: cottage.cottageWindowKind,
  oilLamp: cottage.oilLampKind,
  beam: cottage.beamKind,
  herbs: cottage.herbsKind,
  solid: classic.solidKind,
  transport: classic.transportKind,
  fish: gliderpro.fishBowlKind,
  cobweb: gliderpro.cobwebKind,
  outlet: gliderpro.outletKind,
  shredder: gliderpro.shredderKind,
  cloud: gliderpro.cloudKind,
  mirror: gliderpro.mirrorKind,
  milkCrate: gliderpro.milkCrateKind,
  mousehole: gliderpro.mouseholeKind,
  bear: gliderpro.bearKind,
  cabinet: gliderpro.cabinetKind,
  counter: gliderpro.counterKind,
  guitar: gliderpro.guitarKind,
  chimes: gliderpro.chimesKind,
  faucet: gliderpro.faucetKind,
  floorLamp: gliderpro.floorLampKind,
  tv: appliances.tvKind,
  computer: appliances.computerKind,
  microwave: appliances.microwaveKind,
  vcr: appliances.vcrKind,
  stereo: appliances.stereoKind,
  coffee: appliances.coffeeKind,
  cds: appliances.cdsKind,
  tiki: outdoor.tikiKind,
  bbq: outdoor.bbqKind,
  mailbox: outdoor.mailboxKind,
  flowerBox: outdoor.flowerBoxKind,
  cinderBlock: outdoor.cinderBlockKind,
  filingCabinet: furnishings.filingCabinetKind,
  wasteBasket: furnishings.wasteBasketKind,
  trunk: furnishings.trunkKind,
  stool: furnishings.stoolKind,
  table: furnishings.tableKind,
  bulletin: furnishings.bulletinKind,
  calendar: furnishings.calendarKind,
  tubeLight: fixtures.tubeLightKind,
  trackLight: fixtures.trackLightKind,
  grille: fixtures.grilleKind,
};

export function registerKinds(extra: Record<string, KindDef>): void {
  Object.assign(KINDS, extra);
}
